import * as React from 'react';
import styled from 'styled-components';
import { ContentSpacing, Colors } from '@estee/elc-base-theme';
import { ISelectedItem, IDropdownItem } from '../interfaces/IDropDownItem';
import { dropdownItemTheme } from '../theme/default-theme';
import * as classnames from 'classnames';

const StyledItem = styled.li`
    cursor: pointer;
    padding: ${ContentSpacing.space10};
    font-weight: ${({ isSelectedItem }: ISelectedItem) => (isSelectedItem ? 'bold' : 'normal')};
    background-color: ${({ isSelectedItem }: ISelectedItem) =>
        isSelectedItem ? `${Colors.primary100}` : 'initial'};
    ${dropdownItemTheme};
`;

const IconWrapper = styled.div`
    display: inline-block;
    vertical-align: bottom;
    margin: 0 ${ContentSpacing.space16} 0 ${ContentSpacing.space8};
`;

export const DropdownItem = (props: IDropdownItem) => {
    const { id, onClick, onMouseEnter, item, isSelectedItem, isActiveItem } = props;
    const { label, dataTestId, customAttributes, icon, htmlContent } = item;

    const dropdownClassNames = classnames('elc-dropdown-option', 'js-dropdown-option', {
        highlighted: isSelectedItem,
        active: isActiveItem
    });
    const iconWrapperClassNames = classnames('elc-icon-wrapper', 'js-icon-wrapper');

    return (
        <StyledItem
            id={id}
            role="option"
            onClick={onClick}
            onMouseEnter={onMouseEnter}
            isSelectedItem={isSelectedItem}
            className={dropdownClassNames}
            title={label}
            data-test-id={dataTestId}
            {...customAttributes}
        >
            {icon && (
                <IconWrapper className={iconWrapperClassNames} data-test-id={'dropdown_icon_item'}>
                    {icon}
                </IconWrapper>
            )}
            {htmlContent || label}
        </StyledItem>
    );
};
